import React, { FC } from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { RapidForm } from "../../../../rapidform";
import * as CUSTOMER_INFO_SELECTORS from "../../../state/selectors/customerInfoSelectors";
import { isDeliveryInfoReadOnly } from "../../../state/selectors/deliveryInfoSelectors";
import { getFormById } from "../../../state/selectors/formSelectors";
import TEXT from "../../../text-consts";
import ContactInfo from "../ContactInfo/ContactInfo";

interface StateProps {
    form: Form;
    headingText: string;
    isReadOnly: boolean;
}

interface ContactInfoFormProps extends StateProps {
    onSubmit: (contactPhone: string, contactEmail: string) => void;
}

const ContactInfoForm: FC<ContactInfoFormProps> = ({ form, isReadOnly, headingText, onSubmit }) => {
    function handleOnSubmit() {
        onSubmit(
            _get(form, "values.contactInfo.contactPhone", null),
            _get(form, "values.contactInfo.contactEmail", null),
        );
    }

    return (
        <RapidForm
            id={FORM_ID.CONTACT_INFO}
            action={"#"}
            errors={form.errors}
            values={form.values}
            visible={form.visible}
            onSubmit={handleOnSubmit}
        >
            <ContactInfo headingText={headingText} isReadOnly={isReadOnly} />
        </RapidForm>
    );
};

const mapStateToProps = (state: RootState, ownProps: { headingText: string }): StateProps => ({
    form: getFormById(state, FORM_ID.CONTACT_INFO),
    isReadOnly: isDeliveryInfoReadOnly(state),
    headingText:
        ownProps.headingText ||
        (CUSTOMER_INFO_SELECTORS.hasLegalOwnerEmail(state)
            ? `${TEXT.CONTACT_INFO.HEADING}:`
            : `${TEXT.PERSONAL_DETAILS.LEGAL_OWNER.HEADING}:`),
});

export default connect(mapStateToProps)(ContactInfoForm);
